export const fetchOrganizationConfiguration = payload => {
  return {
    type: "FETCH_ORGANIZATION_CONFIGURATION",
    payload
  };
};
export const saveIbanAndBic = payload => {

  return {
    type: "SAVE_ORGANIZATION_CONFIGURATION",
    payload
  };
}

export const setConfigurationAppType = payload => {

  return {
    type: "SET_APP_TYPE_CONFIG_FILTER",
    payload
  };
}

export const searchUsers = payload => {
  return {
    type: "FETCH_USERS",
    payload
  };
};

export const setSelectedContact = payload => {
  return {
    type: "SET_SELECTED_CONTACT",
    payload
  };
};

export const fetchActions = payload => {
  return {
    type: "FETCH_ACTIONS",
    payload
  };
};

export const fetchEmailTypes = payload => {
  return {
    type: "FETCH_EMAIL_TYPES",
    payload
  };
};

export const saveActionsConfiguration = payload => {

  return {
    type: "SAVE_ACTIONS_CONFIGURATION",
    payload
  };
}

export const setShowButtons = payload => {
  return {
    type: "SET_SHOW_BUTTONS",
    payload
  };
}

export const setRelanceShowButtons = payload => {
  return {
    type: "SET_RELANCE_SHOW_BUTTONS",
    payload
  };
}



// WEBPACK FOOTER //
// ./app/actions/actions/organizationConfiguration.js